import { DateTime } from 'luxon';

import { REGULAR_SEASON_ID } from '../../../../utility/constants';
import { currentReportDefaults } from '../../playersAndTeams/report/current';

const getDefaultReportName = 'summary';

const getReport = (statsConfig, reportName = getDefaultReportName) => {
    const currentSeasonId = statsConfig.fieldDefaultData.seasonId;
    const currentGameTypeId = statsConfig.fieldDefaultData.gameTypeId;
    const currentSeasonData = statsConfig.seasonData[currentSeasonId];

    const isRegSeason = Number(currentGameTypeId) === REGULAR_SEASON_ID;

    const dateFrom = isRegSeason ? currentSeasonData.startDate : currentSeasonData.regularSeasonEndDate;
    const dateTo = isRegSeason ? currentSeasonData.regularSeasonEndDate : currentSeasonData.endDate;
    const isDateToInFuture = DateTime.fromISO(dateTo) > DateTime.local();

    return {
        ...currentReportDefaults,
        dateFrom,
        dateTo: isDateToInFuture ? DateTime.local().toISODate() : dateTo,
        gameTypeId: currentGameTypeId,
        seasonFrom: currentSeasonId,
        seasonTo: currentSeasonId,
        reportName,
    };
};

const getTimeFrameReportData = (timeFrame, seasonData, reportTimeFrameChanged = false) => {
    if (timeFrame === 'allTime') {
        const seasons = Object.keys(seasonData).sort();
        return {
            timeFrame,
            isAggregate: true,
            seasonFrom: parseInt(seasons[0]),
            seasonTo: parseInt(seasons[seasons.length - 1]),
        };
    }

    // When change from By Season to By Game make sure aggregated is true
    if (reportTimeFrameChanged) {
        return {
            timeFrame,
            isAggregate: true,
        };
    }

    return {
        timeFrame,
    };
};

const getDefaultValue = (statsConfig, key) => {
    const defaults = getReport(statsConfig);

    if (!Object.keys(defaults).includes(key)) {
        return null;
        // throw Error`Value ${key} does not exist in the report config`;
    }
    return defaults[key];
};

export default {
    getReport,
    getDefaultReportName,
    getTimeFrameReportData,
    getDefaultValue,
};
